var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 10.6668L4.64489 15.9156C4.68179 16.0633 4.70024 16.1371 4.72207 16.2015C4.93532 16.8311 5.50228 17.2738 6.16478 17.328C6.2326 17.3335 6.30868 17.3335 6.46084 17.3335C6.65138 17.3335 6.74665 17.3335 6.82691 17.3257C7.62018 17.2488 8.24796 16.621 8.3249 15.8277C8.33268 15.7475 8.33268 15.6522 8.33268 15.4617V3.5835M15.416 10.2502C17.0268 10.2502 18.3327 8.94433 18.3327 7.3335C18.3327 5.72267 17.0268 4.41684 15.416 4.41684M8.54101 3.5835H5.41602C3.34495 3.5835 1.66601 5.26244 1.66602 7.33351C1.66602 9.40457 3.34495 11.0835 5.41602 11.0835H8.54102C10.013 11.0835 11.8137 11.8726 13.2029 12.6299C14.0134 13.0717 14.4186 13.2926 14.684 13.2601C14.9301 13.2299 15.1162 13.1194 15.2604 12.9178C15.416 12.7003 15.416 12.2652 15.416 11.3949V3.27207C15.416 2.40183 15.416 1.96671 15.2604 1.74924C15.1162 1.54759 14.9301 1.43709 14.684 1.40694C14.4186 1.37444 14.0134 1.59534 13.2029 2.03713C11.8137 2.79443 10.013 3.5835 8.54101 3.5835Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.63545c2649205d741b4e0270ef9d13c9.svg";
export { ForwardRef as ReactComponent };